import { analytics } from "@perceptron/analytics";

import { env } from "@demo/env";

export { analytics } from "@perceptron/analytics";
export type { CommonEventProperties } from "@perceptron/analytics/types";
export { ANALYTICS_EVENTS } from "./types";
export type { AnalyticsEvent, AnalyticsEventProperties } from "./types";

if (typeof window !== "undefined") {
  analytics.init({
    app: "demo",
    environment: env.NEXT_PUBLIC_APP_ENV,
    gtmId: env.NEXT_PUBLIC_GTM_ID,
    consentStorageKey: env.NEXT_PUBLIC_ANALYTICS_CONSENT_LOCAL_STORAGE_KEY,
    maxQueueSize: env.NEXT_PUBLIC_ANALYTICS_MAX_QUEUE_SIZE,
    queueWarningThreshold: env.NEXT_PUBLIC_ANALYTICS_QUEUE_WARNING_THRESHOLD,
    debug: env.NEXT_PUBLIC_VERCEL_ENV === "development",
  });
}
